var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommonFunc04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 506,
    height: 392,
    viewBox: "0 0 506 392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_481",
    "data-name": "\\uC0AC\\uAC01\\uD615 481",
    width: 506,
    height: 392,
    rx: 20,
    transform: "translate(1004 3312)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_473",
    x: 79,
    y: 60,
    width: 308,
    height: 382,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -20,
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_472",
    "data-name": "\\uC0AC\\uAC01\\uD615 472",
    d: "M25,0H223a25,25,0,0,1,25,25V322H0V25A25,25,0,0,1,25,0Z",
    transform: "translate(854 3478)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "common-func04",
    transform: "translate(-1004 -5387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_11",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 11",
    transform: "translate(0 2075)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_477",
    "data-name": "\\uC0AC\\uAC01\\uD615 477",
    width: 506,
    height: 392,
    rx: 20,
    transform: "translate(1004 3312)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_495",
    "data-name": "\\uADF8\\uB8F9 495",
    transform: "translate(279 -96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 725, 3408)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_473-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 473",
    d: "M25,0H223a25,25,0,0,1,25,25V322H0V25A25,25,0,0,1,25,0Z",
    transform: "translate(129 70)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_9",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 9",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_494",
    "data-name": "\\uADF8\\uB8F9 494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_471",
    "data-name": "\\uC0AC\\uAC01\\uD615 471",
    transform: "translate(854 3478)",
    fill: "#fff",
    stroke: "#12233a",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 427,
    rx: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 242,
    height: 421,
    rx: 22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uACE0\\uAC1D\\uB2D8\\uC758_\\uC758\\uACAC\\uC744_\\uB354_\\uB9CE\\uC774_\\uB4E4\\uC744_\\uC218_\\uC788\\uC744\\uAE4C\\uC694_",
    "data-name": "\\uACE0\\uAC1D\\uB2D8\\uC758 \\uC758\\uACAC\\uC744  \\uB354 \\uB9CE\\uC774 \\uB4E4\\uC744 \\uC218 \\uC788\\uC744\\uAE4C\\uC694?",
    transform: "translate(879 3527)",
    fill: "#12233a",
    fontSize: 16,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uACE0\uAC1D\uB2D8\uC758 \uC758\uACAC\uC744 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "\uB354 \uB9CE\uC774 \uB4E4\uC744 \uC218 \uC788\uC744\uAE4C\uC694?")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC88B\\uC544\\uC694",
    transform: "translate(921 3677)",
    fill: "#2d50b8",
    fontSize: 10,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC88B\uC544\uC694")), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_492",
    "data-name": "\\uADF8\\uB8F9 492",
    transform: "translate(902 3594)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_59",
    "data-name": "\\uD0C0\\uC6D0 59",
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "thumbs-up-solid",
    d: "M4.59,9.886H1.059A1.059,1.059,0,0,0,0,10.945V21.538A1.059,1.059,0,0,0,1.059,22.6H4.59a1.059,1.059,0,0,0,1.059-1.059v-10.6A1.059,1.059,0,0,0,4.59,9.886ZM2.825,20.832a1.059,1.059,0,1,1,1.059-1.059A1.059,1.059,0,0,1,2.825,20.832ZM16.948,3.6c0,1.872-1.146,2.922-1.469,4.173h4.49A2.637,2.637,0,0,1,22.6,10.332a3.2,3.2,0,0,1-.858,2.171h0a3.687,3.687,0,0,1-.411,3.507,3.49,3.49,0,0,1-.723,3.3,2.343,2.343,0,0,1-.271,1.97c-.9,1.294-3.133,1.312-5.021,1.312H15.19a12.67,12.67,0,0,1-5.277-1.4,6.946,6.946,0,0,0-2.324-.714.53.53,0,0,1-.52-.53V10.519a.529.529,0,0,1,.157-.376c1.748-1.728,2.5-3.557,3.933-4.992a5.345,5.345,0,0,0,1.121-2.6c.2-.817.607-2.551,1.5-2.551C14.829,0,16.948.353,16.948,3.6Z",
    transform: "translate(21.844 20.337)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_491",
    "data-name": "\\uADF8\\uB8F9 491",
    transform: "translate(988.063 3594)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_60",
    "data-name": "\\uD0C0\\uC6D0 60",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(-0.063)",
    fill: "#eff0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "thumbs-up-solid-2",
    "data-name": "thumbs-up-solid",
    d: "M4.59,12.711H1.059A1.059,1.059,0,0,1,0,11.652V1.059A1.059,1.059,0,0,1,1.059,0H4.59A1.059,1.059,0,0,1,5.649,1.059V11.652A1.059,1.059,0,0,1,4.59,12.711ZM2.825,1.765a1.059,1.059,0,1,0,1.059,1.06,1.059,1.059,0,0,0-1.059-1.06ZM16.948,19c0-1.872-1.146-2.922-1.469-4.173h4.49A2.637,2.637,0,0,0,22.6,12.265a3.2,3.2,0,0,0-.858-2.171h0a3.687,3.687,0,0,0-.411-3.507,3.49,3.49,0,0,0-.723-3.3,2.343,2.343,0,0,0-.271-1.97C19.428.018,17.2,0,15.308,0h-.126A12.67,12.67,0,0,0,9.905,1.4a6.946,6.946,0,0,1-2.324.714.53.53,0,0,0-.52.53v9.435a.529.529,0,0,0,.157.376c1.748,1.728,2.5,3.557,3.933,4.992a5.345,5.345,0,0,1,1.121,2.6c.2.817.607,2.551,1.5,2.551C14.829,22.6,16.948,22.244,16.948,19Z",
    transform: "translate(21.844 24.103)",
    fill: "#a4a7af"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uBCC4\\uB85C\\uC5D0\\uC694",
    transform: "translate(1003 3677)",
    fill: "#a4a7af",
    fontSize: 10,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uBCC4\uB85C\uC5D0\uC694")), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uD3C9\\uAC00\\uD574_\\uC8FC\\uC154\\uC11C_\\uAC10\\uC0AC\\uD569\\uB2C8\\uB2E4_",
    "data-name": "\\uD3C9\\uAC00\\uD574 \\uC8FC\\uC154\\uC11C \\uAC10\\uC0AC\\uD569\\uB2C8\\uB2E4!",
    transform: "translate(923.28 3732)",
    fill: "#12233a",
    fontSize: 10,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD3C9\uAC00\uD574 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4!")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC55E\\uC73C\\uB85C_\\uB354_\\uC5F4\\uC2EC\\uD788_\\uD558\\uACA0\\uC2B5\\uB2C8\\uB2E4.",
    "data-name": "\\uC55E\\uC73C\\uB85C \\uB354 \\uC5F4\\uC2EC\\uD788 \\uD558\\uACA0\\uC2B5\\uB2C8\\uB2E4.",
    transform: "translate(917.77 3747)",
    fill: "#12233a",
    fontSize: 10,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC55E\uC73C\uB85C \uB354 \uC5F4\uC2EC\uD788 \uD558\uACA0\uC2B5\uB2C8\uB2E4."))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_493",
    "data-name": "\\uADF8\\uB8F9 493",
    transform: "translate(933.279 3752.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1",
    "data-name": "\\uADF8\\uB8F9 1",
    transform: "translate(10.721 7.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M24.373,7.7l-.752.9,1.987,1.665H14.546L11.472,7.7l-.752.9,3.072,2.574v5.91l1.171.976v-6.6H26.67v7.9H14.561l-3.089-2.575-.752.9,3.424,2.869h13.7V10.59Z",
    transform: "translate(-10.721 -7.698)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1",
    "data-name": "\\uC0AC\\uAC01\\uD615 1",
    width: 1.33,
    height: 0.842,
    transform: "translate(6.374 5.977)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2",
    "data-name": "\\uC0AC\\uAC01\\uD615 2",
    width: 1.33,
    height: 0.842,
    transform: "translate(9.429 5.977)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3",
    "data-name": "\\uC0AC\\uAC01\\uD615 3",
    width: 1.33,
    height: 0.842,
    transform: "translate(12.516 5.977)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4",
    "data-name": "\\uC0AC\\uAC01\\uD615 4",
    width: 1.33,
    height: 0.842,
    transform: "translate(6.374 8.6)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5",
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    width: 1.33,
    height: 0.842,
    transform: "translate(9.429 8.6)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6",
    "data-name": "\\uC0AC\\uAC01\\uD615 6",
    width: 1.33,
    height: 0.842,
    transform: "translate(12.516 8.6)",
    fill: "#12233a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2",
    "data-name": "\\uADF8\\uB8F9 2",
    transform: "translate(31.062 12.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    "data-name": "\\uD328\\uC2A4 2",
    d: "M162.418,41.86h3.806v.908h-1.447V46.7h-.935V42.768h-1.424Z",
    transform: "translate(-162.418 -41.86)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3",
    "data-name": "\\uD328\\uC2A4 3",
    d: "M194.254,50.666h.9v3.581h-.9v-.379a1.772,1.772,0,0,1-.528.361,1.486,1.486,0,0,1-.574.11,1.593,1.593,0,0,1-1.2-.538,1.876,1.876,0,0,1-.506-1.338,1.925,1.925,0,0,1,.49-1.36,1.561,1.561,0,0,1,1.19-.53,1.514,1.514,0,0,1,.6.122,1.645,1.645,0,0,1,.523.365Zm-.944.738a.908.908,0,0,0-.692.294,1.175,1.175,0,0,0,0,1.519.908.908,0,0,0,.69.3.926.926,0,0,0,.7-.295,1.079,1.079,0,0,0,.279-.772,1.046,1.046,0,0,0-.279-.757.937.937,0,0,0-.7-.293Z",
    transform: "translate(-187.554 -49.406)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M226.749,45.168V46.38a1.682,1.682,0,0,1,.526-.365,1.521,1.521,0,0,1,.606-.122,1.565,1.565,0,0,1,1.192.53,1.925,1.925,0,0,1,.49,1.36,1.878,1.878,0,0,1-.507,1.338,1.6,1.6,0,0,1-1.2.538,1.5,1.5,0,0,1-.576-.11,1.767,1.767,0,0,1-.53-.361v.379h-.892v-4.4Zm.945,1.555a.936.936,0,0,0-.7.29,1.043,1.043,0,0,0-.28.757,1.075,1.075,0,0,0,.28.772.929.929,0,0,0,.7.3.913.913,0,0,0,.693-.3,1.07,1.07,0,0,0,.281-.763,1.059,1.059,0,0,0-.276-.755.917.917,0,0,0-.7-.3Z",
    transform: "translate(-217.35 -44.724)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5",
    "data-name": "\\uD328\\uC2A4 5",
    d: "M258.309,45.168h.9v4.4h-.9Z",
    transform: "translate(-245.451 -44.724)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6",
    "data-name": "\\uD328\\uC2A4 6",
    d: "M273.6,52.717h-2.887a.96.96,0,0,0,.334.607,1.048,1.048,0,0,0,.693.225,1.2,1.2,0,0,0,.866-.352l.757.356a1.783,1.783,0,0,1-.678.594,2.113,2.113,0,0,1-.938.193,1.854,1.854,0,0,1-1.373-.532,1.81,1.81,0,0,1-.53-1.332,1.872,1.872,0,0,1,.528-1.361,1.777,1.777,0,0,1,1.325-.541,1.842,1.842,0,0,1,1.376.541,1.959,1.959,0,0,1,.53,1.43Zm-.9-.708a.9.9,0,0,0-.351-.487,1.016,1.016,0,0,0-.608-.188,1.076,1.076,0,0,0-.659.211,1.176,1.176,0,0,0-.33.464Z",
    transform: "translate(-255.442 -49.406)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7",
    "data-name": "\\uD328\\uC2A4 7",
    d: "M303.168,41.86h.9l1.122,3.377,1.133-3.377h.9l.813,4.842h-.891l-.519-3.058L305.592,46.7h-.812l-1.02-3.058-.532,3.058h-.9Z",
    transform: "translate(-283.569 -41.86)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8",
    "data-name": "\\uD328\\uC2A4 8",
    d: "M351.163,50.666h.9v3.581h-.9v-.379a1.775,1.775,0,0,1-.528.361,1.487,1.487,0,0,1-.574.11,1.592,1.592,0,0,1-1.2-.538,1.875,1.875,0,0,1-.507-1.338,1.925,1.925,0,0,1,.49-1.36,1.561,1.561,0,0,1,1.19-.53,1.514,1.514,0,0,1,.6.122,1.645,1.645,0,0,1,.523.365Zm-.944.738a.908.908,0,0,0-.692.294,1.176,1.176,0,0,0,0,1.519.908.908,0,0,0,.69.3.927.927,0,0,0,.7-.295,1.079,1.079,0,0,0,.278-.772,1.047,1.047,0,0,0-.278-.757.937.937,0,0,0-.7-.293Z",
    transform: "translate(-323.422 -49.406)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_9",
    "data-name": "\\uD328\\uC2A4 9",
    d: "M382.766,50.666h.9v.367a2.152,2.152,0,0,1,.554-.359,1.339,1.339,0,0,1,.508-.1,1.231,1.231,0,0,1,.9.372,1.278,1.278,0,0,1,.312.934v2.367h-.889V52.679a3.968,3.968,0,0,0-.057-.851.583.583,0,0,0-.2-.32.56.56,0,0,0-.353-.11.661.661,0,0,0-.468.183.974.974,0,0,0-.271.5,4.071,4.071,0,0,0-.039.726v1.437h-.9Z",
    transform: "translate(-353.219 -49.406)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10",
    "data-name": "\\uD328\\uC2A4 10",
    d: "M414.516,50.666h.9v3.581h-.9v-.379a1.765,1.765,0,0,1-.527.361,1.485,1.485,0,0,1-.574.11,1.594,1.594,0,0,1-1.2-.538,1.877,1.877,0,0,1-.506-1.338,1.925,1.925,0,0,1,.49-1.36,1.561,1.561,0,0,1,1.19-.53,1.515,1.515,0,0,1,.6.122,1.644,1.644,0,0,1,.523.365Zm-.944.738a.909.909,0,0,0-.692.294,1.175,1.175,0,0,0,.005,1.519.908.908,0,0,0,.69.3.926.926,0,0,0,.7-.3,1.078,1.078,0,0,0,.279-.772,1.046,1.046,0,0,0-.279-.757.936.936,0,0,0-.7-.293Z",
    transform: "translate(-378.281 -49.406)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11",
    "data-name": "\\uD328\\uC2A4 11",
    d: "M447.747,50.666h.9v3.068a2.027,2.027,0,0,1-.366,1.336,1.83,1.83,0,0,1-1.478.579,2.589,2.589,0,0,1-.885-.132,1.6,1.6,0,0,1-.606-.387,1.582,1.582,0,0,1-.365-.621h.991a.818.818,0,0,0,.339.229,1.4,1.4,0,0,0,.491.078,1.294,1.294,0,0,0,.582-.112.679.679,0,0,0,.311-.29,1.479,1.479,0,0,0,.09-.612,1.478,1.478,0,0,1-.5.341,1.581,1.581,0,0,1-.589.1,1.62,1.62,0,0,1-1.218-.52,2.018,2.018,0,0,1,.03-2.685,1.569,1.569,0,0,1,1.139-.468,1.511,1.511,0,0,1,.585.114,1.856,1.856,0,0,1,.551.373Zm-.932.747a.934.934,0,0,0-.7.285.984.984,0,0,0-.277.716,1,1,0,0,0,.283.734.958.958,0,0,0,.711.286.919.919,0,0,0,.69-.28,1.116,1.116,0,0,0,0-1.46.94.94,0,0,0-.7-.281Z",
    transform: "translate(-407.059 -49.406)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12",
    "data-name": "\\uD328\\uC2A4 12",
    d: "M481.81,52.717h-2.887a.959.959,0,0,0,.334.607,1.048,1.048,0,0,0,.693.225,1.2,1.2,0,0,0,.865-.352l.757.356a1.782,1.782,0,0,1-.679.594,2.111,2.111,0,0,1-.938.193,1.855,1.855,0,0,1-1.373-.532,1.809,1.809,0,0,1-.53-1.332,1.871,1.871,0,0,1,.528-1.361,1.777,1.777,0,0,1,1.325-.541,1.843,1.843,0,0,1,1.376.541,1.96,1.96,0,0,1,.53,1.43Zm-.9-.708a.9.9,0,0,0-.351-.487,1.016,1.016,0,0,0-.608-.188,1.076,1.076,0,0,0-.659.211,1.179,1.179,0,0,0-.33.464Z",
    transform: "translate(-435.731 -49.406)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_13",
    "data-name": "\\uD328\\uC2A4 13",
    d: "M509.916,50.666h.771v.451a.959.959,0,0,1,.332-.4.8.8,0,0,1,.454-.138,1.011,1.011,0,0,1,.505.165l-.253.7a.445.445,0,0,0-.35-.139.609.609,0,0,0-.428.319,2.348,2.348,0,0,0-.143,1.007v1.623h-.892Z",
    transform: "translate(-463.319 -49.406)",
    fill: "#12233a"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonFunc04);
export default __webpack_public_path__ + "static/media/common-func04.bc0970666a38afa461f8571a3e9a74ff.svg";
export { ForwardRef as ReactComponent };